










































import ExecResult from '../../components/exec-result.vue';
import DataprocessForm1 from './dataprocess-form1.vue';
import DataprocessForm7 from './dataprocess-form7.vue';
import DataprocessForm5 from './dataprocess-form5.vue';
import DataprocessForm6 from './dataprocess-form6.vue';
import Component, { mixins } from 'vue-class-component';
import BaseFormMixin from '@/mixins/base-form-mixin';
import DataprocessServices, { DataprocessDto } from '@/services/dataprocess';
import DatajobServices, { TriggerJobDto } from '@/services/datajob';
import { Watch } from 'vue-property-decorator';
import { Mutation, namespace } from 'vuex-class';
import { checkCode } from '@/libs/util';
const System = namespace('System');
@Component({
  components: { ExecResult, DataprocessForm1, DataprocessForm7, DataprocessForm5, DataprocessForm6 }
})
export default class DataprocessForm extends mixins(BaseFormMixin) {

  breadList = [{ name: '编辑流程作业' }];
  dpSrv = new DataprocessServices();
  jobSrv = new DatajobServices();
  formData: DataprocessDto = {};
  loading: boolean = false;
  id: any = 0;
  taskFlowId: any = 0;
  taskNodeId: any = '';
  parentJobCode: any = '';
  keepalive: boolean = true;
  lang: string = 'dorissql';
  setVisible1: boolean = false;
  setVisible2: boolean = false;
  setVisible3: boolean = false;
  setVisible4: boolean = false;
  visibleExecResult: boolean = false;
  sourceDsId: number = 0;

  initFormData() {
    this.formData = {
      taskFlowId: this.taskFlowId,
      taskNodeId: this.taskNodeId,
      parentJobCode: this.parentJobCode,
      // 0-FlinkSQL 1-Python 2-Script 3-Doris
      processJobType: 3,
      glueSource: '',
      sourcesDsConfig: [],
      paramsConfig: [],
      jobConfig: {
        // 0-离线 1-实时
        jobType: 0,
        // 调度方式  0-手动,1-定时,2-周期,3-实时
        triggerMode: 0,
        day: 1,
        weekday: '1',
        season: 0,
        failRetryCount: 3,
        failTimeout: 5,
        cronExpression: '0 0 2 * * ?'
      },
      status: 0,
      templateFlag: 0,
    };
  }

  created() {
    this.id = this.$route.query.id;
    this.taskFlowId = this.$route.query.taskFlowId;
    this.taskNodeId = this.$route.query.taskNodeId;
    this.parentJobCode = this.$route.query.parentJobCode;
    this.initFormData();
  }

  activated() {
    //this.onIdChange();
  }

  refreshKeepalive() {
    if (!this.$route.query.keepalive) {
      this.keepalive = false;
      this.$router.push({
        query: { ...this.$route.query, keepalive: 'true' }
      });
    } else {
      this.keepalive = true;
    }
  }

  @Watch('$route')
  onRouteChange(to: any, from: any) {
    this.id = this.$route.query.id;
    this.taskFlowId = this.$route.query.taskFlowId;
    this.taskNodeId = this.$route.query.taskNodeId;
    this.parentJobCode = this.$route.query.parentJobCode;
    this.cache = this.isNeedCache(from, to);
    this.onIdChange();
  }

  @Watch('id')
  async onIdChange() {
    this.id = this.$route.query.id;
    this.taskFlowId = this.$route.query.taskFlowId;
    this.taskNodeId = this.$route.query.taskNodeId;
    this.parentJobCode = this.$route.query.parentJobCode;
    let path = this.$route.path;
    if (path === '/data/dataprocess/flow/doris') {
      if (this.id) {
        // 详情或编辑
        //if ((!this.id || this.id == this.formData.id) && this.cache) return false;
        
        let res = await this.dpSrv.getInfo(this.id);
        if (!res) return false;
        this.formData.id = this.id;
        this.formData = res;
        this.formData.processJobCode = res.processJobCode?.substring(3);
        this.formData.parentJobCode = this.parentJobCode;
        this.breadList = [{ name: res.taskFlowName || '' }, { name: res.processJobName || '' }, { name: '数据加工流程作业' }];
      } else {
        // 创建
        this.refreshKeepalive();
        //if (this.keepalive && this.cache) return false;
        this.initFormData();
        let flow = await this.dpSrv.getFlowInfo(this.taskFlowId);
        this.breadList = [{ name: flow.flowName }, { name: '创建数据加工流程作业' }];
      }
    }
  }

  routeToConf(e: any) {
    switch (e.key) {
      case "1":
          this.setVisible1 = !this.setVisible1;
          break;
        case "2":
          this.setVisible2 = !this.setVisible2;
          break;
        case "3":
          this.setVisible3 = !this.setVisible3;
          break;
        case "4":
          this.setVisible4 = !this.setVisible4;
          break;
        default:
          break;

    }
  }

  async jobRun() {
    // debugger
    // let jobCode = 'DP_' + this.formData.processJobCode;
    // let jobInfo = await this.jobSrv.getDetail(jobCode);
    // if (jobInfo) {
    //   if (jobInfo.triggerStatus === 0) {
    //     this.$message.error('作业调度状态为停止，请先提交作业。');
    //     return false;
    //   }
    //   let triggerDto: TriggerJobDto = {
    //     executorParam: jobInfo.executorParam,
    //     triggerType: 0,
    //     jobId: jobInfo.id,
    //     jobType: jobInfo.jobType,
    //   };
    //   let res = await this.jobSrv.trigger(triggerDto);
    //   if (!res) return false;
    //   this.$message.success('操作成功');
    // } else {
    //   this.$message.error('作业信息不存在，请先保存提交作业。');
    //   return false;
    // }
    if (this.formData.sourcesDsConfig) {
      this.sourceDsId = this.formData.sourcesDsConfig[0].sourceDsId;
    }
    this.visibleExecResult = true;
  }

  async jobSubmit() {
    let jobCode = 'DP_' + this.formData.processJobCode;
    let jobInfo = await this.jobSrv.getDetail(jobCode);
    if (jobInfo) {
      let res = await this.jobSrv.start(jobInfo.id);
      if (!res) return false;
      this.$message.success('操作成功');
    } else {
      this.$message.error('作业信息不存在，请先保存作业。');
      return false;
    }
  }

  async jobStop() {
    let jobCode = 'DP_' + this.formData.processJobCode;
    let jobInfo = await this.jobSrv.getDetail(jobCode);
    if (jobInfo) {
      let jobLogList = await this.jobSrv.getLogList2(jobCode);
      if (jobLogList && jobLogList.length > 0) {
        let jobLog = jobLogList.get(0);
        let res = await this.jobSrv.stop(jobLog.id);
        res = await this.jobSrv.kill(jobLog);
        if (!res) return false;
        this.$message.success('操作成功');
      }
    } else {
      this.$message.error('作业信息不存在，请先保存提交作业。');
      return false;
    }
  }
  
  async confirm() {
    const must: { field: 'processJobCode' | 'processJobName' | 'processJobDesc' | 'glueSource' ; msessage: string }[] = [
        { field: 'processJobCode', msessage: '数据加工作业编码不能为空' },
        { field: 'processJobName', msessage: '数据加工作业名称不能为空' },
        { field: 'processJobDesc', msessage: '数据加工作业描述不能为空' },
        { field: 'glueSource', msessage: 'DorisSQL语句不能为空' }
    ];
    for (let val of must) {
        if (!this.formData[val.field]) {
          this.$message.error(val.msessage);
          return false;
        }
    }
    if (!checkCode(this.formData.processJobCode)) {
        this.$message.error('编码只能包含英文字母、数字、下划线');
        return false;
    }
    if (!this.id) {
        let code = 'DP_' + this.formData.processJobCode;
        let exist = await this.dpSrv.getList({ processJobCode_eq: code });
        if (exist.length > 0) {
          this.$message.error(`编码[${code}]已经存在`);
          return false;
        }
    }

    if (!this.formData.sourcesDsConfig || this.formData.sourcesDsConfig.length <= 0) {
        this.$message.error('数据源设置不能为空');
        return false;
    }

    let sourceTemp = this.formData.glueSource?.replaceAll(/[\r\n]/g,'\n ');
    this.formData.glueSource = sourceTemp;

    this.loading = true;
    if (this.id) {
      let res = await this.dpSrv.update(this.formData);
      if (res) {
        this.$message.success('更新成功');
        this.replaceUrlWithOutConfirm('/data/dataprocess/flow/detail?id=' + this.taskFlowId);
        this.initFormData();
      }
    } else {
      let res = await this.dpSrv.add(this.formData);
      if (res) {
        this.$message.success('新建成功');
        this.replaceUrlWithOutConfirm('/data/dataprocess/flow/detail?id=' + this.taskFlowId);
        this.initFormData();
      }
    }
    this.loading = false;
  }

}
